"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.profileGeneralValidationSchema = void 0;
const yup_1 = require("yup");
const constants_1 = require("@dzambalaorg/constants");
const constants_2 = require("@framework/constants");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
exports.profileGeneralValidationSchema = (0, yup_1.object)().shape({
    email: yup_rules_1.emailValidationSchema,
    displayName: yup_rules_1.displayNameValidationSchema,
    gender: (0, yup_1.string)().oneOf(Object.values(constants_1.EnabledGenders)).required("form.validations.valueMissing"),
    country: (0, yup_1.string)().oneOf(Object.values(constants_1.EnabledCountries)).required("form.validations.valueMissing"),
    language: (0, yup_1.string)().oneOf(Object.values(constants_2.EnabledLanguages)).required("form.validations.valueMissing"),
    imageUrl: yup_rules_1.urlValidationSchema,
});
//# sourceMappingURL=validation.js.map